<template>
  <v-container fluid>
    <v-row justify="end">
      <v-col cols="12" align="center" justify="center">
        <v-sheet>
          <v-row>
            <v-col cols="9">
              <h1>Priority Onboarding</h1>
            </v-col>
          </v-row>
          <v-data-table
            :headers="table.headers"
            :options="table.options"
            :items="clients"
            :search="search"
            :show-group-by="true"
            :hide-default-footer="true"
            fixed-header
            height="750"
            disable-pagination
            dense
            :loading="loading"
          >
            <template v-slot:top>
              <v-text-field v-model="search" class="mx-4 mt-0 pt-0">
                <template v-slot:label>
                  <v-icon color="secondary"> mdi-magnify </v-icon>
                  Search
                </template>
              </v-text-field>
            </template>
            <template v-slot:[`item.controls`]="props" width="100">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    icon
                    elevation="13"
                    color="secondary"
                    class="ma-1 accent lighten-5"
                    dark
                    v-bind="attrs"
                    v-on="on"
                    @click="openNotes(props.item.client.id)"
                  >
                    <v-icon>mdi-notebook</v-icon>
                  </v-btn>
                </template>
                <span>Notes</span>
              </v-tooltip>
            </template>

            <template v-slot:[`item.clientFullName`]="props">
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <a
                    :href="props.item.profileLink"
                    target="_blank"
                    class="secondary--text text-body-1 text-decoration-none"
                    v-bind="attrs"
                    v-on="on"
                  >
                    {{ props.item.clientFullName }}
                    <br />
                    Phone: {{ props.item.phone }}
                  </a>
                </template>
                <span>Last Login: {{ props.item.client.lastLogin | moment("YYYY-MM-DD HH:MM") }}</span>
              </v-tooltip>
            </template>

            <template v-slot:[`item.product`]="props">
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <span v-bind="attrs" v-on="on">
                    {{ props.item.product }}
                  </span>
                </template>
                <span v-for="email in props.item.emailComms" :key="email.id" class="d-block">
                  {{ email.sgTemplateName }}: {{ email.event }}
                </span>
              </v-tooltip>
            </template>

            <template v-slot:[`item.connectFullName`]="props">
              <v-autocomplete
                v-if="editCell == 'connect-' + props.item.id"
                :value="props.item.connect && props.item.connect.id"
                dense
                :items="staff"
                @change="updateConnectUser($event, props.item.id)"
              ></v-autocomplete>
              <span v-else @click="editCell = 'connect-' + props.item.id" class="fake-link">
                {{ props.item.connectFullName }}
              </span>
            </template>
            <template v-slot:[`item.supportFullName`]="props">
              <v-autocomplete
                v-if="editCell == 'support-' + props.item.id"
                :value="props.item.support && props.item.support.id"
                dense
                :items="staff"
                @change="updateSupportUser($event, props.item.id)"
              ></v-autocomplete>
              <span v-else @click="editCell = 'support-' + props.item.id" class="fake-link">
                {{ props.item.supportFullName }}
              </span>
            </template>
            <template v-slot:[`item.coachFullName`]="props">
              <v-autocomplete
                v-if="editCell == 'coach-' + props.item.id"
                :value="props.item.coach && props.item.coach.id"
                dense
                :items="staff"
                @change="updateCoachUser($event, props.item.id)"
              ></v-autocomplete>
              <span v-else @click="editCell = 'coach-' + props.item.id" class="fake-link">
                {{ props.item.coachFullName }}
              </span>
            </template>
            <template v-slot:[`item.messageSentByUser`]="props">
              <v-icon v-if="props.item.messageSentByUser" color="complete-green">check_circle</v-icon>
              <v-icon v-else color="non-compliant">mdi-close</v-icon>
            </template>
            <template v-slot:[`item.messageSentByCoach`]="props">
              <v-icon v-if="props.item.messageSentByCoach" color="complete-green">check_circle</v-icon>
              <v-icon v-else color="non-compliant">mdi-close</v-icon>
            </template>
          </v-data-table>
          <v-dialog v-model="modals.notes" class="limited-height" width="900" transition="dialog-bottom-transition">
            <user-notes
              v-if="modals.notes"
              :program="selectedProgram"
              :userId="selectedUserId"
              :coachId="currentUser && currentUser.id"
              @problem="emitProblem()"
              @close="closeNotes"
            />
          </v-dialog>
        </v-sheet>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { PRIORITY_ONBOARDING_QUERY } from "@/constants/graphql/operations/onboarding";
import { UPDATE_SUBSCRIPTION_MUTATION } from "@/constants/graphql/users/subscription";
import { STAFF_QUERY } from "@/constants/graphql/users/user";
import { getUserName } from "@/lib/username";
import { fancy_date } from "@/lib/fancy_date";
import UserNotes from "@/components/dashboard/components/notes/UserNotes";

export default {
  name: "HighPriorityOnboarding",
  components: {
    UserNotes,
  },
  data() {
    return {
      clients: [],
      search: "",
      editCell: null,
      staff: [],
      loading: true,
      menu: [],
      selectedProgram: null,
      selectedUserId: null,
      modals: {
        notes: false,
      },
      table: {
        options: {
          showGroupBy: true,
          multiSort: false,
        },
        headers: [
          { text: "Hours since sign up", value: "signUpDateAgeing", groupable: false, width: 100 },
          { text: "Client", value: "clientFullName", groupable: false },
          { text: "Product", value: "product", groupable: false },
          { text: "Onboarding owner", value: "connectFullName", groupable: false },
          {
            text: "",
            value: "controls",
            sortable: false,
            groupable: false,
            filterable: false,
            width: 20,
          },
          { text: "Support team", value: "supportFullName", groupable: false },
          { text: "Coach", value: "coachFullName", groupable: false },
          { text: "Message sent by coach", value: "messageSentByCoach", groupable: false },
        ],
      },
    };
  },
  computed: {
    currentUser() {
      return JSON.parse(localStorage.getItem("user")) || store.getters.user;
    },
  },
  methods: {
    fancyDate(date) {
      return fancy_date(date);
    },
    getName(user) {
      getUserName(user);
    },
    getId(base64string) {
      let decoded = atob(base64string).split(":");
      if (decoded[1]) return decoded[1];
      return "";
    },
    updateConnectUser(event, userSubscriptionId) {
      this.mutateSubscription({
        id: userSubscriptionId,
        connectUserId: event,
      });
    },
    updateSupportUser(event, userSubscriptionId) {
      this.mutateSubscription({
        id: userSubscriptionId,
        supportUserId: event,
      });
    },
    updateCoachUser(event, userSubscriptionId) {
      this.mutateSubscription({
        id: userSubscriptionId,
        coachUserId: event,
      });
    },
    mutateSubscription(input) {
      this.$apollo
        .mutate({
          mutation: UPDATE_SUBSCRIPTION_MUTATION,
          variables: {
            input: input,
          },
          refetchQueries: ["userSubscriptions"],
        })
        .then((result) => {
          if (!result.data.updateSubscriptionRecord.updated) {
            alert(result.data.updateSubscriptionRecord.error);
          } else {
            this.$toasted.success("Updated", {
              icon: "arm-flex",
              duration: 2000,
              position: "bottom-center",
            });
          }
        });
    },
    openNotes(userId) {
      this.selectedUserId = userId;
      this.modals.notes = true;
    },
    closeNotes() {
      this.modals.notes = false;
    },
  },
  apollo: {
    userSubscriptions: {
      query: PRIORITY_ONBOARDING_QUERY,
      variables() {
        this.loading = true;
        let input = {
          stage: "onboarding",
        };
        return input;
      },
      fetchPolicy: "cache-and-network",
      result(response) {
        if (response.data && !response.loading) {
          this.clients = [];

          response.data.userSubscriptions.edges.forEach((item) => {
            if (item.node.coach == null || item.node.supportOwner == null || item.node.messageSentByCoach == false) {
              this.clients.push({
                id: this.getId(item.node.id),
                client: item.node.user,
                clientFullName: getUserName(item.node.user),
                coach: item.node.coach,
                connect: item.node.connectOwner,
                support: item.node.supportOwner,
                connectFullName: item.node.connectOwner ? getUserName(item.node.connectOwner) : "N/S",
                supportFullName: item.node.supportOwner ? getUserName(item.node.supportOwner) : "N/S",
                coachFullName: item.node.coach ? getUserName(item.node.coach) : "N/S",
                profileLink: `/clients/${item.node.user.id}`,
                signUpDateAgeing: this.$moment().diff(this.$moment(item.node.startDate), "hours") + " Hours",
                signUpDate: this.$moment(item.node.startDate).format("YYYY-MM-DD"),
                programStartDate: item.node.programStartDate,
                phone: item.node.user.userProfile.phone,
                onboardingProgram: item.node.onboardingProgram,
                product: item.node.product.name,
                messageSentByCoach: item.node.messageSentByCoach,
                emailComms: item.node.user.userEmailCommunications.filter(
                  (log) => this.$moment(log.createdAt) >= this.$moment(item.node.startDate)
                ),
              });
            }
          });

          this.loading = false;
        }
        if (response.error && response.error.gqlError?.message == "Permission Denied.") {
          this.$router.push("/no-access");
        }
      },
    },
    users: {
      query: STAFF_QUERY,
      variables() {
        return {
          isActive: true,
          isStaff: true,
        };
      },
      fetchPolicy: "cache-and-network",
      result(response) {
        if (response.data && !response.loading) {
          this.staff = [];

          response.data.users.edges.forEach((item) => {
            let data = {
              value: this.getId(item.node.id),
              text: getUserName(item.node),
            };

            this.staff.push(data);
          });

          this.staff.sort((a, b) => (a.text > b.text ? 1 : -1));
        }
        if (response.error && response.error.gqlError?.message == "Permission Denied.") {
          this.$router.push("/no-access");
        }
      },
    },
  },
};
</script>

<style scoped>
.fake-link {
  cursor: pointer;
}
</style>
